import React from 'react'
import { Slider } from '@mui/material';
import { useState } from 'react';
import StatusContext from "../../../contexts/StatusContext";
import './tempslider.css'

export const TempSlider = () => {

    const {
        handleTemperature,
        temperature,
    } = React.useContext(StatusContext);

    const [value, setValue] = useState(temperature)

    const changeValue = (event, value) => {
        setValue(value);
        handleTemperature(value)
      };

    const getText = (valu) => `${value}`;
    const customMarks = [
        {
          value: 0,
          label: '0',
        },
        {
          value: 0.2,
          label: '0.2',
        },
        {
          value: 0.4,
          label: '0.4',
        },
        {
            value: 0.6,
            label: '0.6',
        },
        {
            value: 0.8,
            label: '0.8',
        },
        {
        value: 1,
        label: '1',
        },
  
    ];

  return (
    <div>
      
      <Slider className="tempSlider"
              value={value}
              onChange={changeValue}
              style={{width:200, color:'rgb(59, 75, 93)'}} 
              min={0}
              max={1}
              step={0.1}
              marks={customMarks} 
              valueLabelDisplay='auto'
              getAriaValueText = {getText}
              size = "small"
              

              />
    
    </div>
  )
}

export default TempSlider
